import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Lo stato `mode` di Login.js: accesso o registrazione cambiano nella pagina, senza ricaricarla (i campi
// gia' scritti restano), e il cambio cancella l'errore come setError(""). Anche l'invio cancella l'errore
// precedente (setError("") all'inizio di submit).
// Secondo passaggio (`ticket` di Login.js): il form del codice arriva dopo il primo, che resta nascosto con
// quanto scritto; "Torna a email e password" toglie il secondo e ripresenta il primo.
const TESTI = {
  accedi: { titolo: "Bentornato", sottotitolo: "Accedi ai tuoi progetti e bandi.", invia: "Accedi",
            domanda: "Non hai un account?", cambia: "Registrati" },
  registra: { titolo: "Crea account", sottotitolo: "Inizia ad analizzare le tue idee.", invia: "Registrati",
              domanda: "Hai già un account?", cambia: "Accedi" },
}

export default class extends Controller {
  static targets = ["titolo", "sottotitolo", "nome", "dimenticata", "invia", "domanda", "cambia", "modo", "primo", "secondo"]
  static values = { modo: String }

  cambia() {
    this.modoValue = this.modoValue === "registra" ? "accedi" : "registra"
    this.pulisciErrore()
  }

  modoValueChanged() {
    const registra = this.modoValue === "registra"
    const testi = TESTI[registra ? "registra" : "accedi"]
    for (const chiave of ["titolo", "sottotitolo", "invia", "domanda", "cambia"]) {
      const target = `${chiave}Target`
      if (this[`has${chiave[0].toUpperCase()}${chiave.slice(1)}Target`]) this[target].textContent = testi[chiave]
    }
    if (this.hasModoTarget) this.modoTarget.value = registra ? "registra" : "accedi"
    if (this.hasNomeTarget) {
      this.nomeTarget.hidden = !registra
      this.nomeTarget.querySelectorAll("input").forEach((i) => { i.disabled = !registra })
    }
    if (this.hasDimenticataTarget) this.dimenticataTarget.hidden = registra
  }

  pulisciErrore() {
    this.element.querySelectorAll("#auth-error, #auth-error-2fa").forEach((errore) => {
      const vuoto = document.createElement("div")
      vuoto.id = errore.id
      vuoto.hidden = true
      errore.replaceWith(vuoto)
    })
  }

  secondoTargetConnected(form) {
    if (this.hasPrimoTarget) this.primoTarget.hidden = true
    // autoFocus del campo Codice: anche quando il form arriva con un Turbo Stream
    form.querySelector("[autofocus]")?.focus()
  }

  secondoTargetDisconnected() {
    if (this.hasPrimoTarget && !this.hasSecondoTarget) this.primoTarget.hidden = false
  }

  torna() {
    this.pulisciErrore()
    this.secondoTargets.forEach((form) => form.remove())
    // il biglietto non serve piu': DELETE /login/2fa lo toglie dalla sessione
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch("/login/2fa", {
      method: "DELETE",
      credentials: "same-origin",
      headers: token ? { "X-CSRF-Token": token } : {},
    }).catch(() => {})
  }

  // disabled={loading} del pulsante SMS mentre il form del codice e' in invio
  occupato(event) { this.pulsanteSms(event)?.setAttribute("disabled", "") }

  libero(event) { this.pulsanteSms(event)?.removeAttribute("disabled") }

  pulsanteSms(event) {
    return event.target.closest("form")?.querySelector("[data-testid='login-sms-invia']")
  }

  // inviaSms di Login.js: POST /login/2fa/sms; la risposta (Turbo Stream) aggiorna il blocco SMS o l'errore.
  async inviaSms() {
    this.pulisciErrore()
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const risposta = await fetch("/login/2fa/sms", {
        method: "POST",
        credentials: "same-origin",
        headers: { Accept: "text/vnd.turbo-stream.html", ...(token ? { "X-CSRF-Token": token } : {}) },
      })
      if (!(risposta.headers.get("Content-Type") || "").includes("turbo-stream")) throw new Error("senza dettaglio")
      Turbo.renderStreamMessage(await risposta.text())
    } catch (_) {
      // formatApiErrorDetail(undefined) dell'originale: rete assente o risposta senza dettaglio
      this.mostraErrore2fa("Si è verificato un errore. Riprova.")
    }
  }

  mostraErrore2fa(testo) {
    const vecchio = this.element.querySelector("#auth-error-2fa")
    if (!vecchio) return
    const errore = document.createElement("div")
    errore.id = "auth-error-2fa"
    errore.dataset.testid = "auth-error"
    errore.className = "text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-md px-3 py-2"
    errore.textContent = testo
    vecchio.replaceWith(errore)
  }
}
